const initialState = {
  menuLinks: window.Phoenix.menuLinks,
  hasBeenLoaded: false,
};

const getters = {};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
